import { terminationSteps } from '../b2b-funnel-embed.consts';
import { AddressStep } from './address';
import { ContactPersonStep } from './contact-person';
import { EmailStep } from './email';
import { SolarRequestTypeStep } from './solar-request-type';
export const orderedStepComponents = {
    solarRequestType: SolarRequestTypeStep,
    address: AddressStep,
    contactPerson: ContactPersonStep,
    email: EmailStep
};
const orderedStepNames = Object.keys(orderedStepComponents);
const orderedFormInputStepNames = orderedStepNames.filter((stepName)=>!terminationSteps.includes(stepName));
export const stepProgresses = orderedStepNames.reduce((acc, stepName)=>Object.assign(acc, {
        [stepName]: Math.ceil(100 / orderedFormInputStepNames.length) * orderedFormInputStepNames.indexOf(stepName)
    }), {});

//# sourceMappingURL=all-steps.js.map